import React, { Component } from 'react';
// import cx from 'classnames';

export default class Modal extends Component {

  render() {
    const { children, onBlurClick } = this.props;
    // const modalStyles = cx('cc-modal', {
    //     'cc-modal--open': true
    // });

    return (
      <span>
        <div className="cc-modal">
          <div className="cc-modal-overflow">
            {children}
          </div>
        </div>
        <div className="cc-modal-bg" onClick={onBlurClick} />
      </span>
    )
  }
};



// WEBPACK FOOTER //
// ./src/base/components/Modal/index.js